import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface CountRow { key: string; n: number }
export interface MonthFlowRow { month: string; joins: number; leavers: number }
export interface CompRow { dept: string; currency: string; headcount: number; avgCents: number; medianCents: number; minCents: number; maxCents: number }

export interface AnalyticsOverview {
  headcount: number;
  turnover: { leavers12: number; hires12: number; turnoverPct: number };
  tenure: { buckets: Array<{ bucket: string; n: number }>; avgMonths: number };
  byDepartment: CountRow[];
  byCountry: CountRow[];
  byEmploymentType: CountRow[];
  byStatus: CountRow[];
  monthlyFlow: MonthFlowRow[];
  compensation: CompRow[];
}

export function useAnalyticsOverview() {
  return useQuery({
    queryKey: ['analytics', 'overview'],
    queryFn: async () => (await api.get<AnalyticsOverview>('/api/analytics/overview')).data,
  });
}

export function useAnalyticsAsk() {
  return useMutation({
    mutationFn: async (question: string) => (await api.post<{ answer: string; model: string }>('/api/analytics/ask', { question })).data,
  });
}
